import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { FlexCommunicatorService } from '@fleet/flex/flex-communicator.service';
import { FuseNavigationModule } from '@fleet/fuse';
import { FuseFullscreenModule } from '@fleet/fuse/lib/components/fullscreen';
import { UpdateBannerComponent, VersionBannerComponent } from '@fleet/version';
import { FlexCommunicationBannerComponent } from './flex-communication-banner.component';
import { FleetFlexLayoutComponent } from './fleet-flex-layout.component';

@NgModule({
  declarations: [FleetFlexLayoutComponent],
  exports: [FleetFlexLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    FuseFullscreenModule,
    FuseNavigationModule,
    FlexCommunicationBannerComponent,
    UpdateBannerComponent,
    VersionBannerComponent,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    FlexCommunicatorService,
  ],
})
export class FleetFlexLayoutModule {}
